import {callApi} from '../api'

export const GET_HOLIDAYS = 'GET_HOLIDAYS';
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY';
export const CREATE_HOLIDAY = 'CREATE_HOLIDAY';
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY';

export function getHolidays(cb) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'GET', '/holidays', null, GET_HOLIDAYS, cb);
    }
}

export function updateHoliday(cb, holidayId, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'PATCH', '/holidays/' + holidayId, data, UPDATE_HOLIDAY, cb);
    }
}

export function createHoliday(cb, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'POST', '/holidays', data, CREATE_HOLIDAY, cb);
    }
}

export function deleteHoliday(cb, holidayId, data) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'DELETE', '/holidays/' + holidayId, null, DELETE_HOLIDAY, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/holidays.js